export const observedActions = ['USER_LOGGED_OUT']
export const observedActionsTriggers = {
  USER_LOGGED_OUT: (state, history) => {
    history.push('/laridae/login')
  }
}
